<template>
  <div class="assignments">
    <div class="submissions-app assignment-list">
      <div class="title">
        <h1>Dashboard</h1>
        <div class="tasks--menu">
          <span v-for="(item, key) in menu" :key="key">
            <a
              :href="item.path"
              :class="{'active': activeItem === ('/' + item.path)}"
            >{{ item.title }}</a>
          </span>
        </div>
      </div>
      <div
        ref="sidebar-facets"
        class="sidebar-left"
        :class="{'open':showFilter, 'closed': !showFilter}"
      >
        <div class="facets-title">
          <h1>{{ manageAssignmentsTitle }}</h1>
        </div>
      </div>
      <div class="content">
        <div v-show="showSuccessMessage" class="no-line text-left success-message-wrapper">
          <div class="success-message" v-html="successMessage"></div>
        </div>

        <div v-if="isDataFetched && !resultExist" class="no-data">
          You have not created any {{ assignmentLabel }}. Click <b><i>Create</i></b> and select <b><i>{{ assignmentLabel }}</i></b> to draft your first {{ this.assignmentLabel.toLowerCase() }}.
        </div>

        <div v-else class="list" :key="assignment.id" v-for="assignment in assignments">
          <md-list>
            <md-list-item
              :md-expanded.sync="expandAssignment[assignment.id]"
              md-expand
              :md-ripple="false"
              @click="toggleSubmissions(assignment.id)"
            >
              <div class="assignment-header">
                <div class="row">
                  <span class="assignment-title">
                    <md-icon class="assignment-icon">assignment</md-icon>
                    {{ assignment.title }}
                  </span>
                  <div class="assignment-description">
                    <div class="stats" v-if="assignment.is_draft == 1">
                      <span>Draft</span>
                    </div>
                    <div class="stats" v-else>
                      <div v-if="assignment.assignment_assigned_submissions > 0 ">
                        {{
                        assignment.assignment_assigned_submissions }}
                        <span>assigned</span>
                      </div>
                      <div v-if="assignment.assignment_submitted_submissions > 0 && assignment.type != 'assigned'">
                        &nbsp;| {{
                        assignment.assignment_submitted_submissions }}
                        <span>submitted</span>
                      </div>
                      <div v-if="assignment.assignment_completed_submissions > 0 && assignment.type != 'assigned'">
                        &nbsp;| {{
                        assignment.assignment_completed_submissions }}
                        <span>completed</span>
                      </div>
                    </div>
                  </div>
                  <span
                    class="due-date"
                    v-if="$mq !== 'large' && $mq !== 'xlarge' && assignment.assignment_due_date"
                  >Due {{ assignment.assignment_due_date }}</span>
                  <div class="date">
                    <span
                      class="due-date"
                      v-if="($mq === 'large' || $mq === 'xlarge') && assignment.assignment_due_date"
                    >Due {{ assignment.assignment_due_date }}</span>
                    <popper
                      :stop-propagation="true"
                      :prevent-default="true"
                      :append-to-body="true"
                      ref="assignment-menu"
                      trigger="clickToToggle"
                      :options="{
                      placement: 'left',
                      modifiers: [
                        { offset: {offset: '0,0' } },
                      ]}"
                    >
                      <md-button
                        class="md-button md-icon-button"
                        slot="reference"
                        @click="closePopper('assignment-menu')"
                        ref="popperTrigger"
                      >
                        <md-icon>more_vert</md-icon>
                      </md-button>
                      <div class="assignment-menu">
                        <div class="popper-content">
                          <a :href="editLink(assignment)">Edit</a>
                          <popper
                            :stop-propagation="true"
                            :prevent-default="true"
                            :append-to-body="true"
                            ref="confirm-deleting"
                            trigger="clickToToggle"
                            :options="{
                      placement: 'top',
                      modifiers: [
                        { offset: {offset: '0,0' }},
                      ]}"
                          >
                            <a
                              v-if="(assignment.assignment_submitted_submissions == 0 && assignment.assignment_completed_submissions == 0)"
                              @click="closePopper('assignment-menu')"
                              slot="reference"
                              ref="popperTrigger"
                            >Delete</a>
                            <div class="confirm-deleting">
                              <div class="popper-content">
                                <div class="msg">Delete this item?</div>
                                <div class="actions">
                                  <md-button
                                    @click="deleteAssignment(assignment)"
                                    class="delete md-button"
                                  >Delete</md-button>
                                  <md-button @click="cancel" class="cancel md-button">Cancel</md-button>
                                </div>
                              </div>
                            </div>
                          </popper>
                        </div>
                      </div>
                    </popper>
                  </div>
                </div>
                <div class="icon-more-less">
                  <md-icon class="expand">expand_more</md-icon>
                </div>
              </div>

              <div class="result" slot="md-expand" v-if="showSubmissions && !showLoader">
                <div
                  class="result-wrapper"
                  v-if="showSubmissions[assignment.id] && showSubmissions[assignment.id].length"
                >
                  <div class="mobile" v-if="$mq != 'large' && $mq != 'xlarge'">
                    <div
                      class="row"
                      :key="key"
                      v-for="(submission, key) in showSubmissions[assignment.id]"
                    >
                      <div class="data-wrapper">
                        <div><span class="title">Learner: </span><span v-html="submission.learner"></span></div>
                        <div><span class="title">Group: </span><span v-html="submission.field_group"></span></div>
                        <div v-if="submission.field_role !== ''"><span class="title">Role: </span><span v-html="submission.field_role"></span></div>
                        <div>
                          <span class="title">Status: </span>
                          <span>{{ submission.assignment_submission_status }}</span>
                          <span
                            v-if="submission.assignment_submission_status.toLowerCase() != 'not started'"
                          > ({{ submission.changed }})</span>
                        </div>
                      </div>
                      <div>
                        <div class="view-more">
                          <div
                            v-if="submission.assignment_submission_status.toLowerCase() != 'not started'
                            && assignment.submission_required != 0"
                            v-html="getViewLinkMobile(submission.id)"
                          ></div>
                          <div v-else>Submission: N/A</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="table" v-else>
                    <div class="header">
                      <div>Learner</div>
                      <div>Group</div>
                      <div>Role</div>
                      <div>Status</div>
                      <div v-if="assignment.type == 'assignment'">Submission</div>
                    </div>
                    <div
                      class="row"
                      :key="key"
                      v-for="(submission, key) in showSubmissions[assignment.id]"
                    >
                      <div class="data">
                        <div>{{ submission.learner }}</div>
                        <div>{{ submission.field_group }}</div>
                        <div v-html="submission.field_role"></div>
                        <div>
                          <span>{{ submission.assignment_submission_status }}</span>
                          <br />
                          <span
                            v-if="submission.assignment_submission_status.toLowerCase() != 'not started'"
                          >{{ submission.changed }}</span>
                        </div>
                        <!--<div v-html="getViewLink(submission.id)"></div>-->
                        <div
                          v-if="assignment.type == 'assignment' && submission.assignment_submission_status.toLowerCase() != 'not started' && assignment.submission_required != 0"
                          v-html="getViewLink(submission.id)"
                        ></div>
                        <div v-else-if="assignment.type == 'assignment'">N/A</div>
                      </div>
                    </div>
                  </div>

                  <paginate
                    v-if="pager[assignment.id] && pager[assignment.id].hasOwnProperty('pages') && pager[assignment.id].pages > 1"
                    :click-handler="(page) => {pagerAction(assignment.id, page)}"
                    :page-count="pager[assignment.id].pages"
                    :prev-text="''"
                    :prev-class="'prev'"
                    :next-text="''"
                    :next-class="'next'"
                    :container-class="'pagination'"
                  ></paginate>
                </div>
                <div class="empty" v-else>
                  <span>No data.</span>
                </div>
                <div
                  class="icon-more-less"
                  @click="expandAssignment[assignment.id] = !expandAssignment[assignment.id]"
                >
                  <md-icon class="expand">expand_less</md-icon>
                </div>
              </div>
            </md-list-item>
          </md-list>
        </div>

        <md-button
          v-if="!showLoader && showLoadMore()"
          @click="load"
          class="load-more md-button"
        >Load more</md-button>

        <spinner v-if="showLoader"></spinner>
      </div>
    </div>
  </div>
</template>

<script>
import MenuMixin from "./MenuMixin";
import Popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";
import Spinner from "./components/Spinner.vue";
import Vue from "vue";
import Paginate from "vuejs-paginate";
import HelpersMixin from '@/HelpersMixin'

export default {
  name: "Assignments",

  mounted() {
    this.activeItem = window.location.pathname;

    this.fetchInitialAssignments();
    this.showAssignmentMessage();
    this.clearAssignmentStorage();
  },
  mixins: [MenuMixin, HelpersMixin],
  computed: {
    resultExist() {
      return  this.assignments && this.assignments.length > 0;
    },
    menu() {
      let menu = this.getMainMenu(this.$mq)
        .filter((item) => {
          if (item.path == "rubric-submissions") {
            return item;
          }
        });
      if (menu.length) {
        let submenu = menu[0].items.filter((item) => {
          if (item.restricted) {
            return item.access.call();
          } else {
            return true;
          }
        });
        return submenu;
      }
      return menu;
    },
  },
  components: {
    Spinner,
    Popper,
    Paginate,
  },

  data() {
    return {
      isDataFetched: false,
      activeItem: false,
      showLoader: false,
      assignments: [],
      allAssignments: [],
      pager: [],
      showSubmissions: [],
      submissions: [],
      expandAssignment: [],
      index: 0,
      assignmentsPerPage: 8,
      successMessage: "",
      assignmentLabel: window.drupalSettings.group_catch_config.labels.assignment_label || "Assignment",
      manageAssignmentsTitle: window.drupalSettings.group_catch_config.labels.manage_assignments_title,
    };
  },

  watch: {},

  methods: {
    log(msg) {
      console.log(msg);
    },

    data() {
      return {
        showSuccessMessage: false,
        successMessage: "",
        activeItem: false,
        showLoader: false,
        assignments: [],
        allAssignments: [],
        pager: [],
        showSubmissions: [],
        submissions: [],
        expandAssignment: [],
        index: 0,
        assignmentsPerPage: 8,
        showFilter: false

      };
    },

    showLoadMore() {
      return (
        this.index >= 8 && this.allAssignments.length > this.assignments.length
      );
    },

    pagerAction(assignmentId, page) {
      this.showLoader = true;
      this.getSubmissions(assignmentId, page - 1);
      //this.showLoader = false;
    },

    load() {
      let moreAssignments = this.allAssignments.slice(
        this.index,
        this.index + this.assignmentsPerPage
      );
      if (this.allAssignments.length < this.index + this.assignmentsPerPage) {
        moreAssignments = this.allAssignments.slice(this.index);
      }

      for (let i = 0; i < this.assignmentsPerPage; i++) {
        if (moreAssignments.length == i) {
          return;
        }
        let k = this.assignments.length;
        Vue.set(this.assignments, k, moreAssignments[i]);
        this.index = this.assignments.length;
      }
    },
    getToken() {
      return fetch("/session/token?t=" + Date.now(), {
        credentials: "include",
      })
        .then((response) => {
          return response.text();
        })
        .then((text) => {
          return text;
        });
    },

    editLink(assignment) {
      let postUrl = assignment.type == 'assignment' ? "assignment/" : "assigned/";
      return postUrl + assignment.id + "/edit";
    },

    getViewLinkMobile(id) {
      let link = "<a href='/assignment-submission/" + id + "'>View Submission</a>";
      return link;
    },

    getViewLink(id) {
      let link = "<a href='/assignment-submission/" + id + "'>View</a>";
      return link;
    },

    cancel() {
      this.closePopper("assignment-menu");
      this.closePopper("confirm-deleting");
    },

    closePopper(ref) {
      this.$refs[ref].forEach((popper) => {
        popper.doClose();
      });
    },

    deleteAssignment(assignment) {

      this.loading = true;
      return this.getToken()
        .then((token) => {
          let fetch_headers = new Headers();
          fetch_headers.append("Content-Type", "application/vnd.api+json");
          fetch_headers.append("X-CSRF-Token", token);
          let method = "DELETE";

          let postUrl = assignment.type == 'assignment' ? "/jsonapi/assignment/assignment/" + assignment.assignment_uuid
            : "/jsonapi/assigned/assigned/" + assignment.assignment_uuid;
          return fetch(postUrl, {
            credentials: "include",
            method: method,
            headers: fetch_headers,
          });
        })
        .then(() => {
          return this.fetchInitialAssignments();
        })
        .then(() => {
          //this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    toggleSubmissions(assignmentId) {
      if (event.target.closest(".pagination")) {
        return;
      }
      if (this.showSubmissions.hasOwnProperty(assignmentId)) {
        Vue.set(
          this.expandAssignment,
          assignmentId,
          this.expandAssignment[assignmentId]
        );
        Vue.set(
          this.submissions,
          assignmentId,
          !this.submissions[assignmentId]
        );
      } else {
        Vue.set(this.expandAssignment, assignmentId, false);
        this.showLoader = true;
        this.getSubmissions(assignmentId, null);
        Vue.set(
          this.submissions,
          assignmentId,
          !this.submissions[assignmentId]
        );
      }
    },

    getSubmissions(assignmentId, page) {
      var self = this;
      let assignment = this.assignments.find((item) => {
        return item.id == assignmentId;
      });
      let options = {
        headers: {
          Accept: "application/json; odata=verbose",
          "Content-Type": "application/json",
          "cache-control": "no-cache",
        },
        credentials: "include",
        processData: false,
      };

      let endPoint = '';

      if  (assignment.type == 'assignment') {
        endPoint = "/rest/assignment/" + assignmentId;
      } else {
        endPoint = "/ajax/assigned/" + assignmentId;
      }
      let url = page
        ? endPoint + "/submissions?_format=json&page=" + page
        : endPoint + "/submissions?_format=json";

      fetch(url, options)
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          //self.pager[assignmentId] = data.pager;
          Vue.set(self.pager, assignmentId, data.pager);
          let dataset = self.decorateSubmissionData(data.results, assignment.type);
          Vue.set(self.showSubmissions, assignmentId, dataset);
          this.showLoader = false;
        });
    },

    decorateSubmissionData(results, type) {
      return results ? results.map((data) => {
        if (type == 'assignment') {
          const decodeHtmlCharCodes = (str) =>
            str.replace(/(&#(\d+);)/g, (match, capture, charCode) =>
              String.fromCharCode(charCode)
            );

          return {
            id: data.id,
            changed: data.changed,
            learner: data.learner,
            field_group: decodeHtmlCharCodes(data.field_group),
            field_role: data.field_role,
            assignment_submission_status: data.assignment_submission_status,
          }
        }
        return {
          id: data.id,
          changed: data.changed_2,
          learner: data.uid_3,
          field_group: data.field_group_1,
          field_role: data.field_role_1,
          assignment_submission_status: data.status,
        }
      }) : [];
    },

    decorateData(data) {
      if (data.assignment_type == 'assignment') {
        return {
          id: data.id,
          changed: data.changed,
          assignment_due_date: data.assignment_due_date,
          is_draft: data.is_draft,
          title: data.title,
          assignment_uuid: data.assignment_uuid,
          assignment_assigned_submissions: data.assignment_combined_assigned_submissions,
          assignment_completed_submissions: data.assignment_combined_completed_submissions,
          assignment_submitted_submissions: data.assignment_submitted_submissions,
          submission_required: data.submission_required,
          type: data.assignment_type
        }
      }
      return {
        id: data.id_1_1,
        changed: data.changed_1,
        assignment_due_date: data.due_date_1,
        is_draft: data.is_draft_1,
        title: data.title_1,
        assignment_uuid: data.uuid_2,
        submission_required: data.submission_required,
        type: data.assignment_type,
        activity: data.activity_1,
        assignment_assigned_submissions: data.assignment_combined_assigned_submissions,
        assignment_submitted_submissions: data.assignment_combined_submitted_submissions,
        assignment_completed_submissions: data.assignment_combined_completed_submissions,
      }
    },

    fetchInitialAssignments() {
      this.showLoader = true;
      let options = {
        headers: {
          Accept: "application/json; odata=verbose",
          "Content-Type": "application/json",
          "cache-control": "no-cache",
        },
        credentials: "include",
        processData: false,
      };
      return fetch("/rest/assignments?_format=json", options)
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          this.isDataFetched = true;
          let self = this;
          this.allAssignments = data ? data.map((item) => {
            return self.decorateData(item);
          }) : [];
          this.assignments = [];
          this.index = 0;
          this.load();
          this.showLoader = false;
        })
        .catch(() => {
          this.showLoader = false;
        });
    },
  },
};
</script>

<style lang="scss">
.submissions-app.assignment-list {
  .content {
    padding-top: 10px;
  }
  .md-list-expand-icon {
    display: none;
  }
  .md-list-item-content:hover {
    background: none !important;
  }
  .md-list-item-content.md-ripple {
    -webkit-mask-image: unset !important;
    overflow: unset !important;
    z-index: 2;
    padding-top: 12px;
  }

  .assignment-header {
    width: 100%;
    .row {
      display: flex;
      width: 100%;
      align-items: center;
    }
  }

  .icon-more-less {
    display: flex;
    width: 100%;
    &:hover {
      cursor: pointer;
    }
    i {
      margin: 0 auto;
    }
  }

  .list {
    margin-bottom: 25px;
    .md-icon.expand {
      color: $blue-dark !important;
      font-size: 35px !important;
    }
    ul {
      padding: 0;
      background: unset;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.14);
      border-radius: 20px;
      background: #fff;

      li.md-list-item-expand {
        border: unset;
      }

      li {
        .md-active {
          .assignment-header {
            .icon-more-less {
              display: none !important;
            }
          }
        }
      }
    }
  }
  .md-list-item-expand {
    border: unset;
    z-index: 1;
    overflow: unset !important;
  }
  .md-icon.assignment-icon {
    margin-right: 15px !important;
    color: $blue-active !important;
    width: 2%;
  }
  .assignment-title {
    font-size: 14px;
    font-weight: bold;
    font-family: Source Sans Pro;
    text-transform: capitalize;
    width: 33%;
    white-space: initial;
  }
  .assignment-description {
    width: 33%;
    display: flex;
    align-items: center;
    justify-content: center;
    .stats {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 21px;
      font-family: Source Sans Pro;
      span {
        color: rgb(60, 60, 60);
        font-size: 14px;
      }
    }
  }
  .date {
    width: 33%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    position: relative;
    .due-date {
      color: rgb(124, 124, 124);
      font-size: 14px;
      font-family: Source Sans Pro;
      margin-right: 50px;
    }
    .md-icon {
      color: rgb(60, 60, 60);
    }
  }

  .result {
    border-top: 1px solid $blue-dark;
    padding: 0px;
    .result-wrapper {
      width: 100%;
      .header {
        display: flex;
        width: 100%;
        font-size: 14px;
        font-family: $font-filson-soft;
        text-transform: uppercase;
        color: rgb(60, 60, 60);
        padding: 20px 50px;
        div {
          width: 20%;
          min-width: 100px;
          white-space: initial;
          padding: 5px;
        }
      }
      .row {
        width: 100%;
        padding: 12px 50px;
        border-top: 1px solid rgb(224, 224, 224);
        .data {
          display: flex;
          font-size: 14px;
          font-family: Source Sans Pro;
          color: rgb(60, 60, 60);
          div {
            width: 20%;
            min-width: 100px;
            white-space: initial;
            padding: 5px;
          }
        }
      }

      a {
        color: $blue-active !important;
      }

      .pagination {
        margin-left: 50px;
        margin-top: 15px;
        li {
          padding-left: 5px;
          padding-right: 5px;
        }
        li.prev a:before,
        li.next a:before {
          background-color: unset;
        }
        a {
          font-weight: normal;
          font-size: 14px;
          color: $blue-dark !important;
        }
      }
    }
  }
  .empty {
    margin: 0 auto;
    font-size: 14px;
    padding: 10px 0px;
  }
  .md-button.load-more {
    font-size: 20px;
    background: $blue-dark;
    color: #fff;
    padding: 0px 60px;
    margin: 0 auto;
    display: block;
  }
}

/*.assignment-menu {*/
/*//z-index: 9;*/
/*z-index: 100;*/
/*box-shadow: 0px 0px 4px 0px rgba(60, 60, 60, 0.5);*/
/*border-radius: 18px;*/
/*.popper__arrow {*/
/*//display: none;*/
/*}*/
/*.popper-content {*/
/*width: 110px;*/
/*box-shadow: 0px 0px 4px 0px rgba(60, 60, 60, 0.5);*/
/*background-color: #ffffff;*/
/*a {*/
/*display: block;*/
/*font-size: 14px;*/
/*font-weight: normal;*/
/*line-height: 16px;*/
/*color: rgb(60, 60, 60) !important;*/
/*padding: 10px 20px;*/

/*&:hover {*/
/*background: rgb(245, 245, 245);*/
/*cursor: pointer;*/
/*text-decoration: none;*/
/*}*/
/*}*/
/*}*/
/*}*/

.assignment-menu {
  z-index: 9999;
  -webkit-box-shadow: 0px 0px 4px 0px rgba(60, 60, 60, 0.5);
  box-shadow: 0px 0px 4px 0px rgba(60, 60, 60, 0.5);
  border-radius: 18px;
  background: #fff;
  width: 200px;
  overflow: hidden;
  a {
    display: block;
    font-size: 14px;
    font-weight: normal;
    line-height: 16px;
    color: rgb(60, 60, 60) !important;
    padding: 10px 20px;

    &:hover {
      background: rgb(245, 245, 245);
      cursor: pointer;
      text-decoration: none;
    }
  }
}

.confirm-deleting {
  background: #ffffff;
  color: #333;
  z-index: 100;
  box-shadow: 0px 0px 4px 0px rgba(60, 60, 60, 0.5);
  border-radius: 18px;
}
</style>

